import React, { useState, useEffect, useRef } from 'react';
import { Card, Form, Row, Col, Button, Accordion } from 'react-bootstrap';
import { CompactPicker } from 'react-color';
import QuillInput from './QuilEditor';
import { MDBBadge, MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import { Modal } from 'react-bootstrap';
const availableIcons = [
    'dumbbell', 'running', 'swimmer', 'biking', 'heartbeat', "certificate", "cog", "cogs",
    'walking', 'apple-alt', 'weight', 'fire', 'clock', , "award", "bicycle", "users", "user", "male", "female", "baby", "walking",
    'trophy', 'medal', 'star', 'crown', 'shield-alt', "hiking", "skating", "snowboarding", "atom", "book-open", "football-ball", "hand-holding-usd", "hands", "hands-helping",
    "cookie-bite", "brain", "broom", "bullseye", "camera", "car", "chalkboard-teacher", "baseball-ball", "book", "capsules", "chess-queen", "fist-raised"
];


const PlansEditor = ({ section, onChange, setEditingElement, editingElement, membership }) => {
    const [activeKey, setActiveKey] = useState(['0']);
    const editingTimeoutRef = useRef(null);
    const lastEditingElementRef = useRef(null);
    console.log(membership);

    const [showIconModal, setShowIconModal] = useState(false);
    const [currentPlanIndex, setCurrentPlanIndex] = useState(null);


    useEffect(() => {
        return () => {
            if (editingTimeoutRef.current) {
                clearTimeout(editingTimeoutRef.current);
            }
        };
    }, []);

    const [formData, setFormData] = useState(section);

    useEffect(() => {
        setFormData(section);
    }, [section]);

   

    const handleSetEditingElement = (element, planIndex = null) => {
        if (editingTimeoutRef.current) {
            clearTimeout(editingTimeoutRef.current);
            editingTimeoutRef.current = null;
        }
        const fullElement = planIndex !== null ? `plan-${planIndex}-${element}` : element;
        lastEditingElementRef.current = fullElement;
        setEditingElement(fullElement);
    };

    const handleClearEditingElement = () => {
        if (editingTimeoutRef.current) {
            clearTimeout(editingTimeoutRef.current);
        }
        editingTimeoutRef.current = setTimeout(() => {
            if (editingElement === lastEditingElementRef.current) {
                setEditingElement(null);
            }
        }, 200);
    };

    const updateField = (field, value) => {
        setFormData((prev) => {
            const updated = { ...prev, [field]: value };
            onChange && onChange(updated);
            return updated;
        });
        handleSetEditingElement(field);
    };

    const handlePlanChange = (index, field, value) => {
        const updatedPlans = [...formData.items];
        updatedPlans[index] = { ...updatedPlans[index], [field]: value };

        setFormData((prev) => {
            const updated = { ...prev, items: updatedPlans };
            onChange && onChange(updated);
            return updated;
        });
    };

    const addNewPlan = () => {
        const newPlan = {
            id: `plan-${Date.now()}`,
            planid: "",
            name: "",
            price: "0",
            currency: "₹",
            features: [],
            ispopular: false,
            tagtext: "Best Sell",
            themecolor: "#007bff",
            btntext: "Choose Plan"
        };

        setFormData((prev) => {
            const updated = { ...prev, items: [...prev.items, newPlan] };
            onChange && onChange(updated);
            return updated;
        });
    };

    const removePlan = (index) => {
        const updatedPlans = formData.items.filter((_, i) => i !== index);

        setFormData((prev) => {
            const updated = { ...prev, items: updatedPlans };
            onChange && onChange(updated);
            return updated;
        });
    };

    const handlePlanThemeChange = (index, color) => {
        const updatedPlans = [...formData.items];
        updatedPlans[index] = {
            ...updatedPlans[index],
            themecolor: color.hex
        };

        setFormData((prev) => {
            const updated = { ...prev, items: updatedPlans };
            onChange && onChange(updated);
            return updated;
        });
    };

    const handleMembershipSelect = (index, membershipId) => {
        const selectedMembership = membership.find(m => m._id === membershipId);
        if (!selectedMembership) return;

        const updatedPlans = [...formData.items];
        updatedPlans[index] = {
            ...updatedPlans[index],
            planid: membershipId,
            name: selectedMembership?.displayName || selectedMembership.name,
        };

        setFormData((prev) => {
            const updated = { ...prev, items: updatedPlans };
            onChange && onChange(updated);
            return updated;
        });
    };

    const handleFeatureChange = (planIndex, featureIndex, value) => {
        const updatedPlans = [...formData.items];
        const updatedFeatures = [...updatedPlans[planIndex].features];
        updatedFeatures[featureIndex] = value;
        updatedPlans[planIndex].features = updatedFeatures;

        setFormData((prev) => {
            const updated = { ...prev, items: updatedPlans };
            onChange && onChange(updated);
            return updated;
        });
    };

    const addFeature = (planIndex) => {
        const updatedPlans = [...formData.items];
        updatedPlans[planIndex].features.push("New Feature");

        setFormData((prev) => {
            const updated = { ...prev, items: updatedPlans };
            onChange && onChange(updated);
            return updated;
        });
    };

    const removeFeature = (planIndex, featureIndex) => {
        const updatedPlans = [...formData.items];
        updatedPlans[planIndex].features = updatedPlans[planIndex].features.filter((_, i) => i !== featureIndex);

        setFormData((prev) => {
            const updated = { ...prev, items: updatedPlans };
            onChange && onChange(updated);
            return updated;
        });
    };
    const handleIconSelect = (icon) => {
        if (currentPlanIndex !== null) {
            handlePlanChange(currentPlanIndex, 'icon', icon);
        }
        setShowIconModal(false);
    };

   
    return (
        <div className='overflow-auto'>
            <div className="d-flex justify-content-between align-items-center w-100 pe-3">
                <div className='d-flex align-items-center'>
                    <div className='settingIcon'>
                        <i class="fas fa-tags"></i>
                    </div>
                    <div>
                        <h6 className="mb-0">Membership Plans Settings</h6>
                        <label className="text-muted fw-6">Configure your hero section appearance</label>
                    </div>
                </div>
             
                <div className="d-flex align-items-center">
                    <label className="me-2 mb-0">Active</label>
                    <label className="switch">
                        <input
                            className="form-control"
                            type="checkbox"
                            checked={formData.isactive}
                            onChange={(e) => updateField('isactive', e.target.checked)}
                        />
                        <span className="slider round"></span>
                    </label>
                </div>
            </div>

            <Card className='mt-3 border shadow-0 overflow-hidden '>
                <Accordion activeKey={activeKey} onSelect={(e) => setActiveKey(e)}>
                    {/* Header Section */}
                    <Accordion.Item eventKey="0" className=" border-0">
                        <Accordion.Header className="p-0 bg-transparent border-bottom">
                            <Form.Label className="fw-bold mb-0 d-flex align-items-center"> <i class="fas fa-flag me-2 text-primary"></i>Section Header</Form.Label>
                        </Accordion.Header>
                        <Accordion.Body className="p-0">
                            <Card className="border-0 shadow-sm">
                                <Card.Body>
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-bold'>Subtitle</Form.Label>
                                        <QuillInput
                                            value={formData.subtitle}
                                            onChange={(val) => updateField('subtitle', val)}
                                            onFocus={() => handleSetEditingElement('subtitle')}
                                            onBlur={handleClearEditingElement}
                                            editingElement={editingElement}
                                            fieldName="subtitle"
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-bold'>Title</Form.Label>
                                        <QuillInput
                                            value={formData.title}
                                            onChange={(val) => updateField('title', val)}
                                            onFocus={() => handleSetEditingElement('title')}
                                            onBlur={handleClearEditingElement}
                                            editingElement={editingElement}
                                            fieldName="title"
                                        />
                                    </Form.Group>
                                </Card.Body>
                            </Card>
                        </Accordion.Body>
                    </Accordion.Item>

                    {/* Plans Section */}
                    <Accordion.Item eventKey="1" className="border-0">
                        <Accordion.Header className="p-0 bg-transparent border-bottom">
                            <Form.Label className="fw-bold mb-0 d-flex align-items-center"> <i class="fas fa-address-card me-2 text-primary"></i> Membership Plans</Form.Label>
                        </Accordion.Header>
                        <Accordion.Body className="">
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <h5 className='m-0'>Member Plans</h5>
                                <MDBBtn
                                    className='nav-btnoutline me-2' onClick={addNewPlan} outline size='sm'><i class="fas fa-plus me-2"></i>  Add New Plan</MDBBtn>
                            </div>

                            <Row>
                                {formData.items.map((plan, planIndex) => (
                                    <Col md={6} sm={12} key={plan.id} className="mb-4">
                                        <Card
                                            className="h-100 shadow-0 border"
                                            style={{
                                                borderColor: plan.themecolor || '#007bff',
                                                borderWidth: '2px'
                                            }}
                                        >
                                            {plan.ispopular && (
                                                <div
                                                    className="popular-badge"
                                                    style={{
                                                        backgroundColor: plan.themecolor || '#007bff',
                                                    }}
                                                >
                                                    {plan.tagtext || "POPULAR"}
                                                </div>
                                            )}
                                            <Card.Header className='px-3 py-2 bg-light'>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h5 className='plantext m-0'>Plan {planIndex + 1}</h5>

                                                    <MDBBtn className='clos-btnclos' tag='a' size="sm" color='danger' outline floating onClick={() => removePlan(planIndex)}>
                                                        <MDBIcon fas icon='times' />
                                                    </MDBBtn>
                                                </div>

                                            </Card.Header>
                                            <Card.Body className='p-3'>

                                                <Form.Group className="mb-3">
                                                    <Form.Label className='mb-1'>Plan Name</Form.Label>
                                                    <Form.Select
                                                        value={plan.planid || ""}
                                                        onChange={(e) => handleMembershipSelect(planIndex, e.target.value)}
                                                        onFocus={() => handleSetEditingElement('planid', planIndex)}
                                                        onBlur={handleClearEditingElement}
                                                        className={editingElement === `plan-${planIndex}-planid` ? 'element-highlight' : ''}
                                                    >
                                                        <option value="">Select a membership</option>
                                                        {membership.map((m) => (
                                                            <option key={m._id} value={m._id}>
                                                                {m?.displayName} (<MDBBadge
                                                                    light
                                                                    className="ms-2"
                                                                    color={m.type === "plan" ? "primary" : "success"}
                                                                >
                                                                    {m.type === "plan" ? "Plan" : "Addon"}
                                                                </MDBBadge>)
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='mb-1'>Plan Icon</Form.Label>
                                                    <div className="d-flex align-items-center">
                                                        {plan.icon ? (
                                                            <>
                                                                <MDBIcon icon={plan.icon} className="me-2" size="lg" />
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        setCurrentPlanIndex(planIndex);
                                                                        setShowIconModal(true);
                                                                    }}
                                                                >
                                                                    Change Icon
                                                                </Button>
                                                            </>
                                                        ) : (
                                                            <Button
                                                                variant="outline-primary"
                                                                onClick={() => {
                                                                    setCurrentPlanIndex(planIndex);
                                                                    setShowIconModal(true);
                                                                }}
                                                            >
                                                                <MDBIcon icon="plus" className="me-1" />
                                                                Select Icon
                                                            </Button>
                                                        )}
                                                    </div>
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <Form.Label className='m-0'>Features</Form.Label>
                                                        <Button className='addplan-btn'
                                                            size="sm"
                                                            onClick={() => addFeature(planIndex)}
                                                        >
                                                            <i class="fas fa-plus"></i>
                                                        </Button>
                                                    </div>
                                                    {plan.features.map((feature, featureIndex) => (
                                                        <div key={featureIndex} className="d-flex align-items-center mb-2">
                                                       
                                                            <Form.Control
                                                                type="text"
                                                                value={feature}
                                                                onChange={(e) => handleFeatureChange(planIndex, featureIndex, e.target.value)}
                                                                className={`input-radis ${editingElement === `plan-${planIndex}-feature-${featureIndex}` ? 'element-highlight' : ''}`}
                                                                onFocus={() => handleSetEditingElement(`feature-${featureIndex}`, planIndex)}
                                                                onBlur={handleClearEditingElement}
                                                            />
                                                            <Button className='btn-siz'
                                                                variant="outline-danger"
                                                                size="sm"
                                                                onClick={() => removeFeature(planIndex, featureIndex)}
                                                            >
                                                                ×
                                                            </Button>
                                                        </div>
                                                    ))}
                                                </Form.Group>


                                                <Form.Group className="mb-3">
                                                    <Form.Label className='mb-1'>Button Text</Form.Label>
                                                  
                                                    <Form.Control
                                                        type="text"
                                                        value={plan.btntext}
                                                        onChange={(e) => handlePlanChange(planIndex, 'btntext', e.target.value)}
                                                        onFocus={() => handleSetEditingElement('btntext', planIndex)}
                                                        onBlur={handleClearEditingElement}
                                                        className={editingElement === `plan-${planIndex}-btntext` ? 'element-highlight' : ''}
                                                    />
                                                </Form.Group>
                                                <div
                                                    className={`d-flex align-items-center my-2 ${editingElement === `plan-${planIndex}-ispopular` ? 'element-highlight p-2' : ''}`}
                                                    onFocus={() => handleSetEditingElement('ispopular', planIndex)}
                                                    onBlur={handleClearEditingElement}
                                                >
                                                    <div className='d-flex justify-content-between w-100 align-items-center'>
                                                        <label className="switchlabel me-2 mb-0">Tag/Badge </label>
                                                        <label className="switch">
                                                            <input
                                                                type="checkbox"
                                                                checked={plan.ispopular}
                                                                onChange={(e) => handlePlanChange(planIndex, 'ispopular', e.target.checked)}
                                                            />
                                                            <span className="slider round"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tag/Badge Text
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={plan.tagtext}
                                                        onChange={(e) => handlePlanChange(planIndex, 'tagtext', e.target.value)}
                                                        onFocus={() => handleSetEditingElement('tagtext', planIndex)}
                                                        onBlur={handleClearEditingElement}
                                                        className={editingElement === `plan-${planIndex}-tagtext` ? 'element-highlight' : ''}
                                                    />
                                                </Form.Group>
                                                <Form.Group className="mb-3 planthem">
                                                    <Form.Label className='mb-1'>Plan Theme Color</Form.Label>
                                                    <CompactPicker
                                                        color={plan.themecolor || '#007bff'}
                                                        onChangeComplete={(color) => handlePlanThemeChange(planIndex, color)}
                                                    />
                                                </Form.Group>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>

                    {/* Appearance Section */}
                    <Accordion.Item eventKey="3" className="border-0">
                        <Accordion.Header className="p-0 bg-transparent border-bottom">
                            <Form.Label className="fw-bold mb-0 d-flex align-items-center"> <i class="fas fa-palette me-2 text-warning"></i> Section Appearance</Form.Label>
                        </Accordion.Header>
                        <Accordion.Body className="p-0">
                            <Card className="border-0 shadow-sm">
                                <Card.Body>
                                    <Form.Label>Background Color</Form.Label>
                                    <Form.Group className="mb-3">
                                        <CompactPicker
                                            color={formData.backgroundcolor || '#ffffff'}
                                            onChangeComplete={(color) => updateField('backgroundcolor', color.hex)}
                                        />
                                    </Form.Group>
                                </Card.Body>
                            </Card>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Card>
         
            <Modal show={showIconModal} onHide={() => setShowIconModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Select an Icon</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-wrap">
                        {availableIcons.map((icon) => (
                            <div
                                key={icon}
                                className="m-2 p-2 border rounded cursor-pointer"
                                onClick={() => handleIconSelect(icon)}
                                style={{ width: '60px', textAlign: 'center' }}
                            >
                                <MDBIcon icon={icon} size="2x" />
                                <div className="small mt-1">{icon}</div>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default PlansEditor;